import util from './util';

const syncButtonState = () => (event) => {
    if (event) event.preventDefault();
    let somePending = false;
    util.each(document.querySelectorAll('select[data-initial-value]'), (input) => {
        if (input.value === 'P') somePending = true;
    });

    const submitButton = document.querySelector('button[value=submit]');
    if (somePending) submitButton.setAttribute('disabled', '');
    else submitButton.removeAttribute('disabled');
};

const updateAllDropdowns = async (evt) => {
    const dropdown = evt.currentTarget;
    const newValue = dropdown.value;
    const newValueTitle = document.querySelector(`option[value=${newValue}]`).textContent;
    // In 11.90 we decided to allow people to select empty drop down boxes
    // This returns no value. So we need to escape it.
    if (!newValue) return;

    const newValueType = document.getElementById('bulkupdate-set-all-recommendations')
        .getAttribute('data-data');

    const confirmMsg = `All ${JSON.parse(newValueType).bulkUpdateLabel} will be changed to <strong>${newValueTitle}<strong>`;
    const confirmed = await util.fireDialogBox({
        title: 'Change all statuses',
        message: confirmMsg,
        confirmBtnLabel: 'Change',
        cancelBtnLabel: 'Cancel',
    });

    if (!confirmed.isConfirmed) {
        dropdown.value = '';
        return;
    }

    const data = JSON.parse(dropdown.getAttribute('data-data'));
    const query = `select[name^=${data.name}]`;
    util.each(document.querySelectorAll(query), (select) => {
        select.value = newValue;
        select.dispatchEvent(new Event('change'));
    });

    dropdown.value = '';
};

const handleSubmitClick = async (evt) => {
    evt.preventDefault();
    const button = evt.currentTarget;
    const form = button.form || document.querySelector('.tablelist form[method="POST"]');

    let confirmMsg = button.getAttribute('data-data');
    if (confirmMsg) {
        try {
            confirmMsg = JSON.parse(confirmMsg);
        } catch (e) {
            console.error('error parsing confirm message in attribute data-data');
            confirmMsg = null;
        }
    }

    const { isConfirmed } = await util.fireDialogBox({
        title: confirmMsg.title,
        message: confirmMsg.msg,
        confirmBtnLabel: confirmMsg.confirm,
        cancelBtnLabel: confirmMsg.cancel,
    });
    if (!isConfirmed) return;

    button.setAttribute('disabled', '');
    window.loading.submit();

    const formData = new FormData(form);
    formData.append('noRedirect', 'true');

    ajax({
        url: `${util.urlBase()}${form.getAttribute('action')}`,
        method: 'POST',
        documentType: 'json',
        formData,
        callback(response) {
            if (response.status.value < 0) {
                notification.notify('Error', response.status.text, response.status.value);
                window.loading.remove();
            } else {
                ajax({
                    url: `${util.urlBase() + form.getAttribute('action')}/submit`,
                    method: 'POST',
                    documentType: 'json',
                    callback(response) {
                        button.removeAttribute('disabled');
                        if (response.status.value < 0) {
                            notification.notifyOnVisit('Error', response.status.text, response.status.value);
                            window.location.reload();
                        } else {
                            notification.notifyOnVisit('Success', response.status.text, 0);
                            window.location = response.redirect;
                        }
                    },
                });
            }
        },
    });
};

document.addEventListener('DOMContentLoaded', () => {
    const bulkUpdateDropDown = document.querySelector('[data-callback="bulkupdate_dropdown"]');
    const submitButton = document.querySelector('[data-function=handleSubmitClick]');

    // Bulk update is attached to every page...
    if (bulkUpdateDropDown || submitButton) {
        util.each(document.querySelectorAll('input, select, textarea'), (input) => {
            if (!input.hasAttribute('name')) {
                // Skip fields with no names as they won't be sent to the server
                // such as the "set all recommendations to ..." dropdown
                return;
            }

            input.setAttribute('data-initial-value', input.value);
            input.addEventListener('change', syncButtonState());
            input.addEventListener('reset', syncButtonState());
        });

        bulkUpdateDropDown.addEventListener('change', updateAllDropdowns);
        submitButton.addEventListener('click', handleSubmitClick);
        syncButtonState()(null);
    }
});
